var _clipPath, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 250 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 25
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 150,
    fill: "#e8112d"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(125,75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "r20",
    transform: "scale(0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "r4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "r1",
    d: "m-8.4,108c8.4,22 -9.6,56 8.4,72c-6,-24 14-50 8.4,-72s-25.2,-22 -16.8,0z",
    fill: "#ffef00"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r1",
    transform: "rotate(90)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r1",
    transform: "rotate(180)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r1",
    transform: "rotate(270)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r4",
    transform: "rotate(18)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r4",
    transform: "rotate(36)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r4",
    transform: "rotate(54)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r4",
    transform: "rotate(72)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r20",
    transform: "rotate(9)"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 27,
    fill: "#e8112d"
  }), /*#__PURE__*/React.createElement("circle", {
    cy: -1.5,
    r: 22.5,
    fill: "#ffef00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "x",
    fill: "#e8112d",
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-23.055236,18a37.755236,37.755236 0 1,1 75.510472,0H52.760449a36.260449,36.260449 0 1,0 -72.520898,0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-17.601203,18a35.301203,35.301203 0 1,1 70.602406,0H53.424578a33.924578,33.924578 0 1,0 -67.849156,0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7,-15.052356a33.052356,33.052356 0 1,0 0,66.104712L22.5,49.819805a31.819805,31.819805 0 1,1 0,-63.63961z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#x",
    transform: "scale(-1,1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKg);
export default __webpack_public_path__ + "static/media/kg.350173f1f81b3455bc43fea609105a97.svg";
export { ForwardRef as ReactComponent };